import AppRouter from './router';
import QAFeedbackWidget from './components/QAWidget';
import React, { useEffect, useRef } from 'react';
import { Snackbar, Alert } from '@mui/material';
import { displayNotification } from './utils/notifications';
import { useApolloClient, useReactiveVar } from '@apollo/client/react';
import ErrorBoundary from './components/ErrorBoundary';
import SystemUnavailable from './components/SystemUnavailable';
import { systemUnavailableVar } from './graphql/systemStatus';

const App: React.FC = () => {
  const notification = useReactiveVar(displayNotification);
  const systemUnavailable = useReactiveVar(systemUnavailableVar);
  const client = useApolloClient();
  const wasUnavailable = useRef(false);

  // The outage cover overlays the still-mounted app, so nothing remounts on
  // recovery — instead, re-run the active queries that failed while down
  useEffect(() => {
    if (wasUnavailable.current && !systemUnavailable) {
      client.refetchQueries({ include: 'active' }).catch(() => { });
    }
    wasUnavailable.current = systemUnavailable;
  }, [systemUnavailable, client]);

  return (
    <React.Fragment>
      <ErrorBoundary>
        <AppRouter />
        {systemUnavailable && <SystemUnavailable />}
      </ErrorBoundary>
      {import.meta.env.VITE_QA_WIDGET_ENABLED === 'true' && (
        <QAFeedbackWidget
          claudeApiKey={import.meta.env.VITE_CLAUDE_API_KEY}
          qaApiKey={import.meta.env.VITE_QA_API_KEY}
        />
      )}
      <Snackbar
        open={!!notification.text}
        autoHideDuration={6000}
        onClose={() => displayNotification({ type: "", text: "" })}
      >
        <Alert
          onClose={() => displayNotification({ type: "", text: "" })}
          severity={notification.type === "success" ? "success" : "error"}
          sx={{ width: "100%" }}
        >
          {notification.text}
        </Alert>
      </Snackbar>
    </React.Fragment>
  )
}

export default App
